<template>
  <div class="user-agreement">
    <div class="update-date">{{ $t('manga.agreement.updateDate') }}</div>

    <p class="intro">{{ $t('manga.agreement.intro') }}</p>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.agreement.s1Title') }}</h4>
      <p>{{ $t('manga.agreement.s1Content') }}</p>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.agreement.s2Title') }}</h4>
      <p>{{ $t('manga.agreement.s2Content') }}</p>

      <p><strong>{{ $t('manga.agreement.s2Subtitle1') }}</strong></p>
      <ul>
        <li><strong>{{ $t('manga.agreement.s2Item1').split('：')[0] }}：</strong>{{ $t('manga.agreement.s2Item1').split('：').slice(1).join('：') }}</li>
        <li><strong>{{ $t('manga.agreement.s2Item2').split('：')[0] }}：</strong>{{ $t('manga.agreement.s2Item2').split('：').slice(1).join('：') }}</li>
        <li><strong>{{ $t('manga.agreement.s2Item3').split('：')[0] }}：</strong>{{ $t('manga.agreement.s2Item3').split('：').slice(1).join('：') }}</li>
        <li><strong>{{ $t('manga.agreement.s2Item4').split('：')[0] }}：</strong>{{ $t('manga.agreement.s2Item4').split('：').slice(1).join('：') }}</li>
      </ul>

      <p><strong>{{ $t('manga.agreement.s2Subtitle2') }}</strong></p>
      <ul>
        <li>{{ $t('manga.agreement.s2Item5') }}</li>
        <li>{{ $t('manga.agreement.s2Item6') }}</li>
      </ul>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.agreement.s3Title') }}</h4>
      <p>{{ $t('manga.agreement.s3Content1') }}</p>
      <p>{{ $t('manga.agreement.s3Content2') }}</p>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.agreement.s4Title') }}</h4>
      <p><strong>{{ $t('manga.agreement.s4Content1').split('：')[0] }}：</strong>{{ $t('manga.agreement.s4Content1').split('：').slice(1).join('：') }}</p>
      <p><strong>{{ $t('manga.agreement.s4Content2').split('：')[0] }}：</strong>{{ $t('manga.agreement.s4Content2').split('：').slice(1).join('：') }}</p>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.agreement.s5Title') }}</h4>
      <p>{{ $t('manga.agreement.s5Content1') }}</p>
      <p>{{ $t('manga.agreement.s5Content2') }}</p>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.agreement.s6Title') }}</h4>
      <p>{{ $t('manga.agreement.s6Content') }}</p>
      <ul>
        <li>{{ $t('manga.agreement.s6Item1') }}</li>
        <li>{{ $t('manga.agreement.s6Item2') }}</li>
        <li>{{ $t('manga.agreement.s6Item3') }}</li>
      </ul>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.agreement.s7Title') }}</h4>
      <p>{{ $t('manga.agreement.s7Content') }}</p>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.agreement.s8Title') }}</h4>
      <p>{{ $t('manga.agreement.s8Content') }}</p>
    </div>

    <div class="section">
      <h4 class="section-title">{{ $t('manga.agreement.s9Title') }}</h4>
      <ul>
        <li><strong>{{ $t('manga.agreement.s9Item1').split('：')[0] }}：</strong>{{ $t('manga.agreement.s9Item1').split('：').slice(1).join('：') }}</li>
        <li><strong>{{ $t('manga.agreement.s9Item2').split('：')[0] }}：</strong>{{ $t('manga.agreement.s9Item2').split('：').slice(1).join('：') }}</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.user-agreement {
  color: #cbd5e1;
  line-height: 1.7;
  font-size: 0.95rem;
}

.update-date {
  text-align: right;
  margin-bottom: 1.5rem;
  color: #94a3b8;
  font-size: 0.9rem;
  font-style: italic;
}

.intro {
  margin-bottom: 1.5rem;
  font-weight: 500;
  color: #e2e8f0;
  text-align: justify;
}

.section {
  margin-bottom: 1.5rem;
}

.section-title {
  color: #5eead4;
  font-size: 1.1rem;
  margin-bottom: 0.8rem;
  font-weight: 600;
}

.user-agreement p {
  margin-bottom: 0.8rem;
  text-align: justify;
}

.user-agreement ul {
  margin: 0.8rem 0;
  padding-left: 1.5rem;
}

.user-agreement li {
  margin-bottom: 0.8rem;
  text-align: justify;
  line-height: 1.6;
}

.user-agreement strong {
  color: #5eead4;
  font-weight: 600;
}

.user-agreement {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.user-agreement p,
.user-agreement li {
  word-break: break-word;
  hyphens: auto;
}

@media (max-width: 500px) {
  .user-agreement {
    font-size: 0.9rem;
  }

  .section-title {
    font-size: 1rem;
  }

  .user-agreement ul {
    padding-left: 1.2rem;
  }

  .user-agreement li {
    margin-bottom: 1rem;
    line-height: 1.5;
  }

  .update-date {
    font-size: 0.8rem;
  }
}
</style>
